import Vue from 'vue'
import Router from 'vue-router'
import Cookies from 'js-cookie'

import done from '@/views/start/views/done/done'
import downgrade from '@/views/downgrade/downgrade'
import newTeam from '@/views/start/views/new-team/new-team'
import invalid from '@/views/invalid/invalid'
import billingContactBilling from '@/views/billing-contact-billing/billing-contact-billing'
import success from '@/views/success/success'
import entry from '@/views/entry/entry'
import start from '@/views/onboarding/onboarding'
import name from '@/views/onboarding/views/name/name'
import pay from '@/views/onboarding/views/pay/pay'
import invite from '@/views/onboarding/views/invite/invite'

const account = () => import('@/views/account/account')
const overview = () => import('@/views/overview/overview')
const confirmEmail = () => import('@/views/confirm-email/confirm-email')
const memberOverview = () => import('@/views/member-overview/member-overview')
const domainConfirmed = () => import('@/views/domain-confirmed/domain-confirmed')
const billing = () => import('@/views/billing/billing')
const team = () => import('@/views/team/team')
const authentication = () => import('@/views/authentication/authentication')
const renew = () => import('@/views/renew/renew')
const payment = () => import('@/views/payment/payment')
const accountInvite = () => import('@/views/account-invite/account-invite')

// lazy load components rather than loading them all at once
const base = process.env.CONFIG.name === 'development' ? '/' : '/team'

Vue.use(Router)
export default new Router({
  mode: 'history',
  base: base,
  routes: [
    {
      path: '/success',
      name: 'success',
      component: success
    },
    {
      path: '/invalid-invite',
      name: 'invalid',
      component: invalid
    },
    {
      path: '/confirm-email',
      name: 'confirm-email',
      component: confirmEmail
    },
    {
      path: '/billing',
      name: 'billing-contact-billing',
      component: billingContactBilling,
      meta: { requiresAuth: true }
    },
    {
      path: '/domain-confirmed',
      name: 'domainConfirmed',
      component: domainConfirmed,
      meta: { requiresAuth: true }
    },
    {
      path: '/renew',
      name: 'renew',
      component: renew,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/payment',
      name: 'payment',
      component: payment,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/account',
      name: 'account',
      component: account,
      children: [
        {
          path: 'overview',
          name: 'overview',
          alias: 'subscription',
          component: overview,
          meta: {
            requiresAuth: true,
            noScroll: true
          },
          beforeEnter: (to, from, next) => {
            if (Cookies.getJSON('TB_SESSION') && Cookies.getJSON('TB_SESSION').tb4t === 'MEMBER') {
              next({ replace: true, name: 'member-overview' })
            } else {
              next()
            }
          }
        },
        {
          path: 'overview/member',
          name: 'member-overview',
          component: memberOverview,
          meta: {
            requiresAuth: true,
            noScroll: true
          },
          beforeEnter: (to, from, next) => {
            if (Cookies.getJSON('TB_SESSION') && Cookies.getJSON('TB_SESSION').tb4t === 'ADMIN') {
              next({ replace: true, name: 'overview' })
            } else {
              next()
            }
          }
        },
        {
          path: 'billing',
          name: 'billing',
          component: billing,
          meta: {
            requiresAuth: true,
            noScroll: true
          }
        },
        {
          path: 'team',
          name: 'team',
          component: team,
          meta: {
            requiresAuth: true,
            noScroll: true
          }
        },
        {
          path: 'invite',
          name: 'account-invite',
          component: accountInvite,
          meta: {
            requiresAuth: true,
            noScroll: true
          }
        }
      ],
      beforeEnter: (to, from, next) => {
        if (to.path === '/account') {
          next({ replace: true, name: 'overview' })
        } else {
          next()
        }
      }
    },
    {
      path: '/account/login',
      name: 'login',
      alias: ['/login', '/log-in'],
      component: authentication
    },
    {
      path: '/account/signup',
      name: 'signup',
      alias: ['/signup', '/sign-up'],
      component: authentication
    },
    {
      path: '/create',
      alias: '/join',
      name: 'entry',
      component: entry,
      beforeEnter: (to, from, next) => {
        if (Cookies.getJSON('TB_SESSION') &&
          (Cookies.getJSON('TB_SESSION').tb4t === 'ADMIN' ||
          Cookies.getJSON('TB_SESSION').tb4t === 'MEMBER')) {
          next({ replace: true, name: 'overview' })
        } else {
          next()
        }
      }
    },
    {
      path: '/start',
      name: 'start',
      component: start,
      children: [
        {
          path: 'name',
          name: 'name',
          component: name
        },
        {
          path: 'pay',
          name: 'pay',
          component: pay
        },
        {
          path: 'invite',
          name: 'invite',
          component: invite
        },
        {
          path: 'done',
          name: 'done',
          component: done
        },
        {
          path: 'new-team',
          name: 'new-team',
          component: newTeam
        }
      ],
      beforeEnter: (to, from, next) => {
        if (to.path === '/start') {
          next({ replace: true, name: 'name' })
        } else {
          next()
        }
      }
    },
    {
      path: '/downgrade',
      name: 'downgrade',
      component: downgrade
    },
    {
      path: '*',
      redirect: to => {
        if (Cookies.getJSON('TB_SESSION')) {
          if (Cookies.getJSON('TB_SESSION').tb4t === 'ADMIN') {
            return { name: 'overview' }
          } else if (Cookies.getJSON('TB_SESSION').tb4t === 'MEMBER') {
            return { name: 'member-overview' }
          }
        }
        return { name: 'entry' }
      }
    }
  ],
  scrollBehavior: function (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js